export default {
  selectedArtwork (state) {
    return state.artworks[state.artworkCounter]
  },

  hasNext (state) {
    return ! (state.artworks.length === (state.artworkCounter + 1))
      && state.artworks.length > 0
  },

  hasPrevious (state) {
    return state.artworkCounter !== 0

  }
}
